/* eslint-disable import/prefer-default-export */

// import { ColumnMappings } from 'components/types'; // Not used anymore
import { buildCustomOperatorFieldDefaults } from '../utils/customOperatorFieldDefaults';

export interface WeighedFormValues {
  mass: { value: number | string; unit: string };
  containerMass: { value: number | string; unit: string };
  volumetricMass: { value: number | string; unit: string };
  [key: string]: { value: number | string; unit: string };
}

export const getDefaultFormValues = (
  itemData: Record<string, unknown>,
  columnMappings: any, // New mappingConfig.columns format
  customOperatorFields: string[] = [],
  previousItemFormValues: Partial<WeighedFormValues> | undefined = undefined,
): WeighedFormValues => {
  const getCsv = (key: string) => columnMappings?.[key]?.mapping?.csvName;
  const getUnit = (key: string, fallback = '') => (columnMappings?.[key]?.mapping?.unit || fallback);

  const massCsv = getCsv('mass');
  const containerMassCsv = getCsv('containerMass');
  const volumetricMassCsv = getCsv('volumetricMass');

  const getVal = (key: string | undefined): unknown => (key ? itemData[key] : '');

  return {
    mass: { value: (getVal(massCsv) as string) || '', unit: getUnit('mass', 'kg') },
    containerMass: { value: (getVal(containerMassCsv) as string) || '', unit: getUnit('containerMass', 'kg') },
    volumetricMass: { value: (getVal(volumetricMassCsv) as string) || '', unit: getUnit('volumetricMass', 'g/L') },
    ...buildCustomOperatorFieldDefaults({
      itemData,
      columnMappings,
      customOperatorFields,
      previousItemFormValues,
    }),
  };
};
